module.exports = __webpack_public_path__ + "static/img/detail_ninjetown_02.df46714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ninjatown-ninja-builder/detail_ninjetown_02.jpg
// module id = 266
// module chunks = 2